// extracted by mini-css-extract-plugin
export default {"chipsBox":"index_chipsBox_f-aDb","chips":"index_chips_Sy-2C"};